import eq from 'fast-deep-equal/react';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deepEquals = (arg1: any, arg2: any) => eq(arg1, arg2);
